module.exports = __webpack_public_path__ + "img/temp_h.0c3f1dc6.png";